import PropertyList from '../controller'
import View from './view'

export default class PropertyFutureList extends PropertyList {
    
    constructor(finder) {
        super(finder)
        this.view = new View(this)
        
        this.title = 'Kommande bostäder: '
    }
    
    fillPropertyTabs() {
        this.setActiveTab('projekts')
        if (this.props.projekts) {
            super.fillPropertyTabs({
                projekts: this.props.projekts,
                objekts: [],
            })
        }
        return this
    }
    
    manage(data) {
        this.reset()
        this.props.objekts = []
        this.props.projekts = data.projekts.filter(p => /kommande|planerat/i.test(p.props.status))
        this.view.initObjektsPagination()
        return this
    }
}
